import { ListObligation } from "models/list-obligation";
import { doGet, doPatch, parseListPath } from "../request";
import { LocaleString } from "models/locale";
import { List } from "models/list";

export const adminDoPatchListObligation = async (
  list: List,
  text: LocaleString,
) => {
  const obligation = await doPatch<ListObligation>(
    parseListPath(list, "obligation"),

    { text },
  );
  return obligation;
};

export const adminDoGetListObligation = async (list: List) => {
  const obligation = await doGet<ListObligation>(
    parseListPath(list, "obligation"),
  );
  return obligation;
};
